import React from 'react'
import Panaroma from './components/Panaroma';

function App() {
  return (
    <Panaroma/>
  );
}

export default App;
